module.exports = __webpack_public_path__ + "static/media/ic_success_checked.7d307bf3.svg";